import React from 'react';

const GhlFooter: React.FC = () => {
  return (
    <footer className="py-12 bg-slate-950 border-t border-slate-900 text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
        <div className="text-slate-500 mb-4 md:mb-0">
          &copy; {new Date().getFullYear()} ProGeoData. All rights reserved.
          <span className="text-slate-600 ml-2">| Not affiliated with GoHighLevel Inc.</span>
        </div>

        <div className="flex space-x-6">
          <a href="/" className="text-slate-500 hover:text-white transition-colors">Home</a>
          <a href="/marketers" className="text-slate-500 hover:text-white transition-colors">For Marketers</a>
          <a href="/privacy" className="text-slate-500 hover:text-white transition-colors">Privacy Policy</a>
          <a href="/terms" className="text-slate-500 hover:text-white transition-colors">Terms of Service</a>
          <a href="/docs" className="text-slate-500 hover:text-white transition-colors">API Docs</a>
        </div>
      </div>
    </footer>
  );
};

export default GhlFooter;
